import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 10;

function ProdutoList() {
  const [produtos, setProdutos] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [page, setPage]       = useState(1);
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState('asc');
  const navigate = useNavigate();

  useEffect(() => {
    fetchProdutos();
  }, []);

  const fetchProdutos = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await api.get('/produtos/', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProdutos(response.data);
    } catch {
      toast.error('Erro ao carregar os produtos.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir este produto?')) return;
    try {
      const token = localStorage.getItem('access_token');
      await api.delete(`/produtos/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProdutos(produtos.filter((p) => p.id !== id));
      toast.success('Produto excluído.');
    } catch {
      toast.error('Erro ao excluir o produto.');
    }
  };

  const formatCurrency = (v) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);

  const filtered = produtos.filter((p) =>
    p.nome.toLowerCase().includes(search.toLowerCase())
  );
  const sorted = sortKey
    ? [...filtered].sort((a, b) => {
        const va = a[sortKey] ?? ''; const vb = b[sortKey] ?? '';
        const cmp = typeof va === 'string' ? va.localeCompare(vb, 'pt-BR') : Number(va) - Number(vb);
        return sortDir === 'asc' ? cmp : -cmp;
      })
    : filtered;
  const totalPages = Math.ceil(sorted.length / PAGE_SIZE);
  const paginated  = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handleSort = (key) => {
    if (sortKey === key) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortKey(key); setSortDir('asc'); }
    setPage(1);
  };

  const getStatus = (qty, minimo = 5) => {
    if (qty === 0)    return { label: 'Sem estoque', cls: 'badge-error' };
    if (qty < minimo) return { label: 'Crítico',     cls: 'badge-warn' };
    return                   { label: 'Em estoque',  cls: 'badge-ok' };
  };

  return (
    <div className="produto-page">

      {/* Page sub-header */}
      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Produtos</h2>
          <div className="produto-tabs">
            <span className="produto-tab active">Lista de Produtos</span>
            <span className="produto-tab" onClick={() => navigate('/produtos/novo')}>
              Adicionar Produto
            </span>
          </div>
        </div>
        <div className="produto-header-actions">
          <div className="produto-search-wrap">
            <span className="material-symbols-outlined">search</span>
            <input
              type="text"
              placeholder="Buscar produto..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            />
          </div>
          <button className="prd-btn-primary" onClick={() => navigate('/produtos/novo')}>
            <span className="material-symbols-outlined">add</span>
            Novo Produto
          </button>
        </div>
      </div>

      {/* Table card */}
      <div className="prd-card prd-table-card">
        <div className="prd-card-accent" />
        <div className="prd-table-toolbar">
          <span className="prd-table-count">
            {filtered.length} produto{filtered.length !== 1 ? 's' : ''}
          </span>
          <button className="prd-icon-btn" onClick={fetchProdutos} title="Atualizar">
            <span className="material-symbols-outlined">refresh</span>
          </button>
        </div>

        <div className="prd-table-wrap">
          <table className="prd-table">
            <thead>
              <tr>
                <th className={`th-sort${sortKey === 'nome' ? ' sort-active' : ''}`} onClick={() => handleSort('nome')}>
                  Produto <span className="material-symbols-outlined th-sort-icon">{sortKey === 'nome' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more'}</span>
                </th>
                <th>Descrição</th>
                <th className={`center th-sort${sortKey === 'quantidade_estoque' ? ' sort-active' : ''}`} onClick={() => handleSort('quantidade_estoque')}>
                  Estoque <span className="material-symbols-outlined th-sort-icon">{sortKey === 'quantidade_estoque' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more'}</span>
                </th>
                <th className="center">Status</th>
                <th className={`right th-sort${sortKey === 'preco' ? ' sort-active' : ''}`} onClick={() => handleSort('preco')}>
                  Preço <span className="material-symbols-outlined th-sort-icon">{sortKey === 'preco' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more'}</span>
                </th>
                <th className="right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 4 }).map((_, i) => (
                  <tr key={i}>
                    {Array.from({ length: 6 }).map((__, j) => (
                      <td key={j}><div className="skeleton" /></td>
                    ))}
                  </tr>
                ))
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan={6} className="prd-empty">
                    {search ? 'Nenhum produto encontrado.' : 'Nenhum produto cadastrado.'}
                  </td>
                </tr>
              ) : (
                paginated.map((p) => {
                  const st = getStatus(p.quantidade_estoque, p.estoque_minimo ?? 5);
                  return (
                    <tr key={p.id}>
                      <td className="td-name">
                        <div className="td-name-wrap">
                          <div className="td-thumb">
                            {p.imagem && (
                              <img src={p.imagem} alt={p.nome} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }} />
                            )}
                          </div>
                          <span>{p.nome}</span>
                        </div>
                      </td>
                      <td className="td-desc">{p.descricao || '—'}</td>
                      <td className="center td-stock">{p.quantidade_estoque}</td>
                      <td className="center">
                        <span className={`badge ${st.cls}`}>{st.label}</span>
                      </td>
                      <td className="right td-price">{formatCurrency(p.preco)}</td>
                      <td className="right">
                        <div className="td-actions">
                          <button
                            className="prd-icon-btn"
                            onClick={() => navigate(`/produtos/editar/${p.id}`)}
                            title="Editar"
                          >
                            <span className="material-symbols-outlined">edit</span>
                          </button>
                          <button
                            className="prd-icon-btn prd-icon-btn--danger"
                            onClick={() => handleDelete(p.id)}
                            title="Excluir"
                          >
                            <span className="material-symbols-outlined">delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <Pagination page={page} totalPages={totalPages} onPageChange={(p) => { setPage(p); window.scrollTo(0,0); }} />
      </div>
    </div>
  );
}

export default ProdutoList;
